import React from "react";

const CONTACT_HREF =
  "mailto:fed@moonscroll.ai?subject=API%20Access&body=Hi%2C%20I%27d%20like%20to%20chat%20about%20API%20access%20and%20our%20requirements.";

/**
 * Shown when the user can open API screens but does not have the api feature flag.
 */
const ApiAccessEmptyState = () => {
  return (
    <div className="text-center py-16">
      <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-theme-secondary flex items-center justify-center">
        <svg
          className="w-10 h-10 text-theme-text opacity-30"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
          />
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-theme-text mb-2">API access</h3>
      <p className="text-theme-text opacity-60 max-w-md mx-auto mb-2">
        Call Moonscroll from your own tools and agents. Generate ideas and scripts,
        pull audiences and patterns, and wire Moonscroll into your product workflows.
      </p>
      <p className="text-theme-text opacity-60 max-w-md mx-auto mb-6 text-sm">
        We want to chat about your API requirements and get you set up.
      </p>
      <a
        href={CONTACT_HREF}
        className="inline-flex px-4 py-2 rounded-md bg-theme-primary text-theme-button hover:opacity-90"
        style={{ backgroundColor: "var(--theme-primary)", color: "var(--theme-button-text)" }}
      >
        Contact us
      </a>
    </div>
  );
};

export default ApiAccessEmptyState;
